
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoashtavinayakinnovatourpackages() {



    const cardData =
    {
        keyword: ' Pune to Ashtavinayak Innova Tour Package',
        heading: 'Prince Cabs: Pune to Ashtavinayak Innova Tour Package',
        headingDescription: 'Prince Cabs offers a specially curated Pune to Ashtavinayak Innova Tour Package, perfect for devotees seeking a comfortable and hassle-free pilgrimage to the eight sacred Ganpati temples. Our spacious Innova and Innova Crysta vehicles are well-maintained and equipped with modern amenities, ensuring a safe and enjoyable journey across all temple locations. With professional chauffeurs, flexible itineraries, and on-time service, we make your Ashtavinayak Darshan convenient and memorable. Experience devotion, comfort, and reliability with Prince Cabs’ trusted Innova tour package from Pune to Ashtavinayak.',

        top: 'Top Places to Visit in Ashtavinayak with Prince Cabs',

   "topPlaces": [
  {
    "title": "Shree Mayureshwar Temple, Morgaon",
    "description": "Located in Morgaon near Pune, Shree Mayureshwar is considered the first and most important temple of the Ashtavinayak Yatra. The idol depicts Lord Ganesha seated on a peacock, symbolizing wisdom and strength. The temple was built in the 14th century by the saint Morya Gosavi. Pilgrims begin and end their Ashtavinayak journey here. Its black stone structure with four gates represents all directions. The temple exudes a serene and spiritual aura."
  },
  {
    "title": "Shree Siddhivinayak Temple, Siddhatek",
    "description": "Siddhatek, on the banks of the Bhima River in Ahmednagar district, houses the powerful Shree Siddhivinayak temple. It is believed that Lord Vishnu achieved victory over demons here by meditating on Lord Ganesha. The idol is right-trunked, considered very auspicious and rare. Pilgrims climb a small hill to reach the shrine. Surrounded by natural beauty, it is both spiritually and scenically enriching. Devotees believe wishes made here are always fulfilled."
  },
  {
    "title": "Shree Ballaleshwar Temple, Pali",
    "description": "The Shree Ballaleshwar temple in Pali, Raigad district, is unique as it is named after a devotee of Ganesha, Ballal. The temple’s architecture resembles the shape of a ‘Shree’ in Devanagari script. The idol has diamonds embedded in its eyes and sits with Riddhi and Siddhi. The temple is surrounded by scenic Sahyadri hills. Pilgrims believe worship here blesses them with prosperity and devotion. It highlights the bond between the Lord and his devotee."
  },
  {
    "title": "Shree Varadvinayak Temple, Mahad",
    "description": "Shree Varadvinayak temple in Mahad, Raigad district, is known as the granter of wishes. Unlike other Ashtavinayak temples, devotees are allowed to personally perform rituals and touch the idol. The temple is surrounded by a water tank and lush greenery. The idol is self-manifested (Swayambhu) and discovered in 1690. Pilgrims often light oil lamps that burn continuously here. It is believed prayers here are always answered with blessings."
  },
  {
    "title": "Shree Chintamani Temple, Theur",
    "description": "Located near Pune, the Shree Chintamani temple is associated with the legend of sage Kapila and the Chintamani gem. Lord Ganesha retrieved the gem and returned it to the sage, hence the name Chintamani, meaning remover of worries. The temple is built in Peshwa style with a spacious courtyard. The idol is studded with precious jewels, adding grandeur. Theur is one of the busiest temples of the Ashtavinayak circuit. Devotees believe worship here brings peace of mind."
  },
  {
    "title": "Shree Girijatmaj Temple, Lenyadri",
    "description": "Shree Girijatmaj temple is the only Ashtavinayak shrine located inside a cave, part of the Lenyadri Buddhist rock-cut caves. The idol is carved on a rock wall, facing north, which is unique among the eight temples. Legend says Goddess Parvati performed penance here and Ganesha was born to her. The temple requires climbing 300+ steps but rewards with panoramic views of the valley. Its cave setting adds to the mystique. It combines devotion with adventure."
  },
  {
    "title": "Shree Vighnahar Temple, Ozar",
    "description": "Shree Vighnahar temple in Ozar is known as the remover of obstacles. It was renovated by Chimaji Appa, brother of Peshwa Bajirao I, after his victory over the Portuguese at Vasai. The temple is fortified with stone walls and features deepmalas (lamp towers). The idol is covered in armor of gold, enhancing its grandeur. Festivals like Ganesh Chaturthi are celebrated with great fervor here. It is a powerful pilgrimage destination."
  },
  {
    "title": "Shree Mahaganapati Temple, Ranjangaon",
    "description": "Shree Mahaganapati temple in Ranjangaon, near Pune, houses a large idol of Lord Ganesha with 10 trunks and 20 arms, though only a smaller idol is visible to devotees. Legend says Lord Shiva worshipped Ganesha here before his battle with demon Tripurasura. The temple was expanded by Madhavrao Peshwa in the 18th century. Its impressive architecture and sanctity attract thousands of pilgrims. Ranjangaon is traditionally visited last in the Ashtavinayak circuit."
  }
],

"services": [
    {
        "name": "Pune to Ashtavinayak Innova Car Package Service",
        "description": "Book a complete Innova car package from Pune to Ashtavinayak for a smooth and spiritually fulfilling journey. Our package includes all major Ganpati temples, well-planned routes, tolls, and experienced drivers familiar with religious circuits, ensuring a peaceful and memorable tour for families or groups."
    },
    {
        "name": "Pune to Ashtavinayak Innova Cab",
        "description": "Travel comfortably from Pune to all eight Ashtavinayak temples in a spacious Innova cab. Ideal for pilgrim groups or families, this service offers plenty of room for passengers and luggage, air-conditioned rides, and trusted drivers who make your devotional journey safe and seamless."
    },
    {
        "name": "Pune to Ashtavinayak Innova Taxi Fare",
        "description": "Check our transparent and affordable Innova taxi fare for the Pune to Ashtavinayak circuit. With fixed pricing, no hidden charges, and complete inclusion of driver fees and fuel, you get a stress-free pilgrimage ride with excellent value for money and premium service."
    },
    {
        "name": "Pune to Ashtavinayak Innova Crysta Taxi Fare",
        "description": "Explore premium comfort at an affordable rate with our Innova Crysta taxi fare for the Ashtavinayak trip from Pune. Designed for long-distance religious tours, our Crysta taxis come with luxury interiors, reliable drivers, and cost-effective pricing tailored for family pilgrimages."
    },
    {
        "name": "Pune to Ashtavinayak Innova Crysta Cab Booking",
        "description": "Easily book an Innova Crysta cab from Pune for the full Ashtavinayak Darshan tour. With online booking, instant confirmation, and experienced chauffeurs, our service ensures a smooth, luxurious, and divine travel experience across all eight sacred temples."
    },
    {
        "name": "Pune to Ashtavinayak Innova Round Trip",
        "description": "Plan your round trip from Pune to all eight Ashtavinayak temples with our dedicated Innova cab service. This round-trip booking covers full temple routes, return journey, and offers flexibility in scheduling stops, temple timings, and rest breaks for your convenience."
    },
    {
        "name": "Pune to Ashtavinayak Innova Family Cab",
        "description": "Make your family’s religious journey special with our Innova cab for Ashtavinayak Darshan. With seating for 6-7 passengers, ample luggage space, and a smooth ride, our family-friendly service ensures comfort, safety, and convenience throughout your holy trip."
    },
    {
        "name": "Pune to Ashtavinayak Innova Tour Price",
        "description": "Get the best tour price for your Pune to Ashtavinayak Innova journey. Our all-inclusive packages cover temple routes, fuel, and driver allowances, offering maximum comfort and value. Great for spiritual seekers looking for organized and affordable travel."
    },
    {
        "name": "Pune to Ashtavinayak Innova Dzire Alternative",
        "description": "Upgrade from Dzire to Innova for a more comfortable and spacious Ashtavinayak trip. Perfect for groups and families, Innova offers better legroom, smoother suspension, and a superior travel experience, making long hours on the road more relaxing and enjoyable."
    },
    {
        "name": "Affordable Innova Cab to Ashtavinayak",
        "description": "Choose our affordable Innova cab service for your Ashtavinayak Darshan from Pune. Without compromising on comfort or safety, we offer clean, air-conditioned vehicles and courteous drivers who guide you through all temple visits with ease and devotion."
    }
],
"tableData": [
    ["Pune to Ashtavinayak Innova Car Package Service", "Pune to Ashtavinayak Innova Cab"],
    ["Pune to Ashtavinayak Innova Taxi Fare", "Pune to Ashtavinayak Innova Crysta Taxi Fare"],
    ["Pune to Ashtavinayak Innova Crysta Cab Booking", "Pune to Ashtavinayak Innova Round Trip"],
    ["Pune to Ashtavinayak Innova Family Cab", "Pune to Ashtavinayak Innova Tour Price"],
    ["Pune to Ashtavinayak Innova Dzire Alternative", "Affordable Innova Cab to Ashtavinayak"]
],


"whychoose": [
    {
        "WhyChooseheading": "Comprehensive Pune to Ashtavinayak Innova Tour Package",
        "WhyChoosedescription": "Prince Cabs offers a thoughtfully curated Innova tour package covering the sacred Ashtavinayak pilgrimage from Pune. This package is perfect for devotees who want a hassle-free, comfortable, and spiritually enriching journey to all eight revered Ganesha temples around Pune, including Siddhivinayak, Ballaleshwar, Varadavinayak, and more."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Innova Vehicles for Group Travel",
        "WhyChoosedescription": "Our Toyota Innova cabs are ideal for families, friends, or groups undertaking the Ashtavinayak tour. With ample legroom, reclining seats, and generous luggage space, our vehicles ensure that every passenger enjoys a relaxed ride during this full-day or multi-day pilgrimage."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Pilgrimage Route Knowledge",
        "WhyChoosedescription": "Our drivers are well-acquainted with the Ashtavinayak temple circuit and Pune’s traffic conditions, ensuring smooth navigation and timely arrivals at each temple. Their familiarity with the routes helps optimize the journey, allowing you to spend more time in devotion and less time on the road."
    },
    {
        "WhyChooseheading": "Customizable Tour Itineraries to Suit Your Schedule",
        "WhyChoosedescription": "Prince Cabs offers flexible tour packages—from single-day express tours to multi-day relaxed pilgrimages. You can customize the itinerary, pick-up and drop-off points, and even include additional stops such as nearby cultural or natural attractions along the way."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Standards for Peace of Mind",
        "WhyChoosedescription": "We prioritize your health and safety with thoroughly sanitized vehicles before every trip, well-maintained Innova cabs, and strict adherence to safety protocols. This ensures a safe and comfortable journey, especially important during extended tours."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Multiple Payment Options",
        "WhyChoosedescription": "Our pricing is upfront and competitive, covering all travel expenses including tolls and driver allowance. We accept various payment methods like UPI, credit/debit cards, net banking, and cash, making your booking experience smooth and hassle-free."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Seamless Travel Experience",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist you with bookings, itinerary adjustments, or any queries during your Ashtavinayak tour, ensuring your spiritual journey is worry-free and memorable."
    }
]




















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Ashtavinayak Innova tour packages?',
        answer: 'Yes, Prince Cabs provides customized Innova tour packages from Pune to all eight Ashtavinayak temples, perfect for religious pilgrims and groups.',
    },
    {
        question: 'What is included in the Pune to Ashtavinayak Innova tour package?',
        answer: 'Our package includes a comfortable Innova cab with a professional driver, flexible itinerary covering all Ashtavinayak temples, and optional stops for meals and sightseeing.',
    },
    {
        question: 'How many days does the Ashtavinayak tour usually take by Innova?',
        answer: 'Typically, the tour spans 1 to 2 days depending on your schedule and preferences. We offer both single-day and multi-day packages.',
    },
    {
        question: 'Can I customize the tour itinerary?',
        answer: 'Absolutely! You can customize pickup times, temple visit order, and additional stops. Our team will help tailor the tour to your needs.',
    },
    {
        question: 'Are the Innova cabs used for the tour sanitized and comfortable?',
        answer: 'Yes, all Innova cabs are regularly sanitized, well-maintained, and equipped with comfortable seating for a pleasant journey.',
    },
    {
        question: 'What are the charges for the Pune to Ashtavinayak Innova tour package?',
        answer: 'Charges depend on the duration, number of temples visited, and any additional services. Contact Prince Cabs for a personalized quote.',
    },
    {
        question: 'How do I book the Pune to Ashtavinayak Innova tour package?',
        answer: 'You can book easily via our website or call our customer care. Provide your travel dates and preferences, and we will arrange everything for you.',
    },
];

const testimonials = [
    {
        name: "Mr. Manish Kulkarni",
        position: "Pilgrim",
        text: "The Pune to Ashtavinayak Innova tour with Prince Cabs was seamless and comfortable. The driver was knowledgeable and punctual throughout the trip.",
        image: "/img/testimonial/testimonial-thumb-ashtavinayak-1.png",
    },
    {
        name: "Mrs. Sangeeta Deshmukh",
        position: "Devotee",
        text: "Our family had a wonderful experience on the Ashtavinayak tour package. The Innova was spacious and well-maintained, making the trip enjoyable.",
        image: "/img/testimonial/testimonial-thumb-ashtavinayak-2.png",
    },
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Innova Tour Package",
  "image": "https://princecab.com/assets/images/pune-to-ashtavinayak-innova-tour.jpg",
  "description": "Book Pune to Ashtavinayak Innova tour package with Prince Cabs. Comfortable and affordable Innova Crysta taxi service for your pilgrimage and family tours.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5000",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-ashtavinayak-innova-tour-package"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Ashtavinayak Innova Tour Package | Comfortable Innova Taxi</title>
  <meta
    name="description"
    content="Book Pune to Ashtavinayak Innova tour package with Prince Cabs. Comfortable and affordable Innova Crysta taxi service for your pilgrimage and family tours."
  />
  <meta
    name="keywords"
    content="Pune to Ashtavinayak Innova Car Package Service, Pune to Ashtavinayak Innova Cab, Pune to Ashtavinayak Innova Taxi Fare, Pune to Ashtavinayak Innova Crysta Taxi Fare, Pune to Ashtavinayak Innova Crysta Cab Booking, Pune to Ashtavinayak Innova Round Trip, Pune to Ashtavinayak Innova Family Cab, Pune to Ashtavinayak Innova Tour Price, Pune to Ashtavinayak Innova Dzire Alternative, Affordable Innova Cab to Ashtavinayak"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayakinnovatourpackages ;